module.exports = __webpack_public_path__ + "static/media/jumper.170fb581.jpg";